import { createContext, useState, useMemo, useContext } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

const ThemeContext = createContext();

export const useAppTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  const toggleMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === 'light'
            ? {
                primary: {
                  main: '#1a237e',
                  light: '#534bae',
                  dark: '#000051',
                  contrastText: '#ffffff',
                },
                secondary: {
                  main: '#00897b',
                  light: '#4ebaaa',
                  dark: '#005b4f',
                  contrastText: '#ffffff',
                },
                background: {
                  default: '#f0f2f5',
                  paper: '#ffffff',
                },
              }
            : {
                primary: {
                  main: '#5c6bc0',
                  light: '#8e99f3',
                  dark: '#26418f',
                  contrastText: '#ffffff',
                },
                secondary: {
                  main: '#26a69a',
                  light: '#64d8cb',
                  dark: '#00766c',
                  contrastText: '#ffffff',
                },
                background: {
                  default: '#121212',
                  paper: '#1e1e1e',
                },
              }),
          success: {
            main: '#2e7d32',
          },
          error: {
            main: '#c62828',
          },
        },
        typography: {
          fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
          h4: { fontWeight: 700 },
          h5: { fontWeight: 600 },
          h6: { fontWeight: 600 },
        },
        shape: {
          borderRadius: 10,
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 8,
              },
            },
          },
          MuiPaper: {
            styleOverrides: {
              root: {
                borderRadius: 10,
              },
            },
          },
        },
      }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={{ mode, toggleMode }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};
